module.exports = __webpack_public_path__ + "/images/mockup_lista-es-no-fondo.82d6117.png";